/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import type SearchScope from "sap/f/gen/ui5/webcomponents_fiori/dist/SearchScope";
import type SearchItem from "sap/f/gen/ui5/webcomponents_fiori/dist/SearchItem";
import type SearchItemGroup from "sap/f/gen/ui5/webcomponents_fiori/dist/SearchItemGroup";
import type Search from "sap/f/gen/ui5/webcomponents_fiori/dist/Search";
import type Avatar from "sap/f/gen/ui5/webcomponents/dist/Avatar";
import type Button from "sap/f/gen/ui5/webcomponents/dist/Button";
import type IllustratedMessage from "sap/f/gen/ui5/webcomponents_fiori/dist/IllustratedMessage";
import type UnableToUpload from "sap/f/gen/ui5/webcomponents_fiori/dist/illustrations/UnableToUpload";
import type webcomponents from "sap/f/gen/ui5/webcomponents";

export interface WebComponents {
    SearchScope: SearchScope;
    SearchItem: SearchItem;
    SearchItemGroup: SearchItemGroup;
    Search: Search;
    Avatar: Avatar;
    Button: Button;
    Ui5WebComponents: webcomponents; // For enums
    IllustratedMessage: IllustratedMessage;
    UnableToUpload: UnableToUpload;
}

const searchScopeLoadPath = "sap/f/gen/ui5/webcomponents_fiori/dist/SearchScope";
const searchItemLoadPath = "sap/f/gen/ui5/webcomponents_fiori/dist/SearchItem";
const searchItemGroupPath = "sap/f/gen/ui5/webcomponents_fiori/dist/SearchItemGroup";
const searchLoadPath = "sap/f/gen/ui5/webcomponents_fiori/dist/Search";
const avatarLoadPath = "sap/f/gen/ui5/webcomponents/dist/Avatar";
const buttonLoadPath = "sap/f/gen/ui5/webcomponents/dist/Button";
const ui5WebComponentsLoadPath = "sap/f/gen/ui5/webcomponents";
const illustratedMessageLoadPath = "sap/f/gen/ui5/webcomponents_fiori/dist/IllustratedMessage";
const unableToUploadLoadPath = "sap/f/thirdparty/ui5/webcomponents_fiori/dist/illustrations/UnableToUpload";

export async function loadWebComponents(): Promise<WebComponents> {
    return {
        SearchScope: (await import(searchScopeLoadPath)).default,
        SearchItem: (await import(searchItemLoadPath)).default,
        SearchItemGroup: (await import(searchItemGroupPath)).default,
        Search: (await import(searchLoadPath)).default,
        Avatar: (await import(avatarLoadPath)).default,
        Button: (await import(buttonLoadPath)).default,
        IllustratedMessage: (await import(illustratedMessageLoadPath)).default,
        UnableToUpload: (await import(unableToUploadLoadPath)).default,
        Ui5WebComponents: (await import(ui5WebComponentsLoadPath)).default,
    };
}
